import * as React from "react";

import {
  autoUpdate,
  flip,
  offset,
  shift,
  useDismiss,
  useFloating,
  useInteractions,
  useRole,
} from "@floating-ui/react";

import { PopoverOptions } from "./types";

export function usePopover({ initialOpen = false, placement = "bottom" }: PopoverOptions = {}) {
  const [open, setOpen] = React.useState(initialOpen);

  const data = useFloating({
    placement,
    open,
    onOpenChange: setOpen,
    whileElementsMounted: autoUpdate,
    middleware: [
      offset(5),
      flip({
        crossAxis: placement.includes("-"),
        fallbackAxisSideDirection: "end",
        padding: 5,
      }),
      shift({ padding: 5 }),
    ],
  });

  const context = data.context;

  const dismiss = useDismiss(context);
  const role = useRole(context);

  const interactions = useInteractions([dismiss, role]);

  return {
    ...interactions,
    ...data,
  };
}
